// Types
import type { ReactNode } from 'react';

import clsx from 'clsx';

// Lib
import { PENDO_CLASS_SIGNUP_STEP_ADD_SP_ALL_NETWORK } from '@/lib/tools/pendo/class';

import Badge from '@/components/base/Badge';
import Button from '@/components/base/Button';
// Components
import Icon from '@/components/base/Icon';

type SocialProfileConnectButtonProps = Omit<React.ComponentProps<typeof Button>, 'icon'> & {
    title: string;
    subtitle: string;
    icon: ReactNode;
    showBetaBadge?: boolean;
};

const SocialProfileConnectButton = ({
    title,
    subtitle,
    icon,
    onClick,
    className,
    showBetaBadge,
    ...restProps
}: SocialProfileConnectButtonProps) => {
    return (
        <Button
            variant="white"
            className={clsx(
                'relative flex items-center space-x-3',
                PENDO_CLASS_SIGNUP_STEP_ADD_SP_ALL_NETWORK,
                className
            )}
            onClick={onClick}
            {...restProps}>
            {showBetaBadge ? (
                <div className="absolute -right-1 -top-2">
                    <Badge variant="beta" shorten={false} />
                </div>
            ) : null}
            <span
                className={clsx(
                    'flex h-10 w-10 items-center justify-center rounded-full bg-icoGray-100 text-center',
                    { 'opacity-40': restProps.disabled }
                )}>
                {icon}
            </span>
            <span className="flex flex-1 flex-col py-2 text-left">
                <span className="text-base">{title}</span>
                <span className="text-xxs text-icoGray-400">{subtitle}</span>
            </span>
            <Icon
                icon="plus"
                className={clsx('rounded-full bg-icoBlue-100 p-0.5 text-icoBlue', {
                    'opacity-40': restProps.disabled
                })}
            />
        </Button>
    );
};

export default SocialProfileConnectButton;
